// 标准产品编码
export const projectCode = {
  topProjectOnlineCode: 'P0121', // 拔尖线上项目
  topProjectAutumnOnlineCode: 'P0131', // 拔尖线上秋季项目
  topProjectAllOnlineCode: 'P0121,P0132', // 全部线上拔尖项目
  topProjectOfflineCode: 'P0122', // 拔尖实地项目
  topProjectCode: 'P0121,P0122', // 拔尖春季项目
  topProjectAllCode: 'P0121,P0122,P0132', // 拔尖项目
  oneVipProjectCode: 'P0125', // 1v1项目
  overseasProjectCode: 'P0124', // 海外实地英美科研
  singaporeProjectCode: 'P0130', // 海外实地新加坡
  overseasProjectAllCode: 'P0124,P0130', // 全部海外实地项目
  overseasAndOneProjectCode: 'P0124,P0130,P0125', // 海外和1v1编码
  allProjectCode: 'PL00086', // 全部项目编码
  PL00031: 'PL00031', // 20250707
}

// 海外校区值
export const overseasSchoolCity = {
  westSchoolCity: '19,20',  // 英美校区
  columbiaSchool: '19', // 哥伦比亚大学校区
  oxfordSchool: '20', // 牛津大学校区
  singaporeSchoolCity: '23', // 新加坡校区
  allSchoolCity: '19,20,23'
}

// 招生状态
export const QuotaStatus = {
  1: '招生',
  2: '紧张',
  3: '满额',
  4: '停招',
}

// 名额海报招生状态
export const posterStatus = {
  1: '招生中',
  2: '名额紧张',
  3: '已满额',
  4: '停止招生',
}

export const courseType = {
  1: 'NeoSchool平台直播',
  2: 'NeoSchool平台直播 + 线下实地授课',
  3: 'NeoSchool平台直播 + 线下实地授课'
}

// 校区地址
export const courseCity = {
  11: '北京校区',
  12: '上海校区',
  13: '广州校区',  // 广州 · 大学城校区
  14: '杭州 · 西湖校区',
  15: '成都 · 华西校区',
  16: '武汉 · 东湖校区',
  17: '南京 · 四牌楼校区',
  18: '西安 · 雁塔校区',
  19: '美国 · 哥伦比亚大学校区',
  20: '英国 · 牛津大学校区',
  21: '英国 · 剑桥大学校区',
  22: '广州校区',  // 广州 · 白云校区
  23: '新加坡 · 新加坡国立大学'
}

//课题难度
export const courseDifficulty = {
  1: 'General',
  2: 'In-depth'
}
